import api from "./api";

export const getAllHosts = async (schemaName = null) => {
  try {
    const response = await api.get("/hosts/", {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching hosts:", error);
    throw error;
  }
};

export const createHost = async (hostData, schemaName = null) => {
  try {
    const response = await api.post("/hosts/", hostData, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating host:", error);
    throw error;
  }
};


export const updateHost = async (id,hostData, schemaName = null) => {
  try {
    const response = await api.put(`/hosts/${id}/`, hostData, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating host:", error);
    throw error;
  }
}; 


export const deleteHost = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/hosts/${id}/`, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting host:", error);
    throw error;
  }
};  